import LicenceDataSource, { ILicenceStoreConfig } from '../datasource/LicenceDataSource';
import AuthStore from '../store/AuthStore';
import CustomStore from 'devextreme/data/custom_store';
import { ObjectUtils } from './ObjectUtils';

const makeAsyncDS = (url) => {
    return new CustomStore({
      loadMode: 'raw',
//      group:'Id',
      key: 'Id',
      load() {
        return fetch(url)
//          .then((response) => response.json())
          .then((response) => response.json())
          .then((response) => response.data)
        
        ;
      },
      byKey: (key) => {
        return key;
      },
    });
  }

const getStore = (storeConfig: ILicenceStoreConfig) => {
    return LicenceDataSource.licenceStore(
        storeConfig
    );
}

const getStore_1 = (storeConfig: ILicenceStoreConfig) => {
    return makeAsyncDS(storeConfig.url);
}

/*

function isArray(obj) {
    return !!obj && obj.constructor === Array;
}
const evalAllProperty = (obj, rootObj) => {
    if (typeof obj !== "object") return;
    if (isArray(obj)) {
        for (let item of obj) {
            evalAllProperty(item, rootObj);
        }
    }
    else {
        for (let key in obj) {
            if (typeof obj[key] == "object") {
                evalAllProperty(obj[key], rootObj);
            }
            else if (typeof obj[key] == "string" && obj[key]) {
                let value = obj[key];
                try {
                    value = eval(value);
                    if (typeof value == "function") {
                        try {
                            value = value(obj, rootObj);
                            obj[key] = value;
                        }
                        catch {

                        }
                    }
                }
                catch {

                }
//                typeof eval("(args)=>{let x = 100 + args; return x;}")
//                obj[key] = obj[key].toUpperCase();
            }
        }
    }
}
*/

const setItems = (items, authStore) => {
    items = items || [];
    ObjectUtils.evalAllProperty(items, items, true, 1, 100 );
    for (let item of items) {
        if (item["editorType"] != "dxButton") {
//            evalAllProperty(item, item);
        }
        if (item["editorType"] == "dxDateBox") {
            if (item["editorOptions"]?.value == "now") {
                item["editorOptions"].value = new Date();
            }
        }
        if (item["editorOptions"]) {
            let dataSource = item["editorOptions"]["dataSource"];
            if (dataSource) {
                let url;
                if (typeof dataSource == "string") {
                    url = dataSource
                }
                else if (typeof dataSource == "object" && dataSource["store"] && typeof dataSource["store"] == "string") {
                    url = dataSource["store"]
                }
                if (url) {
                    if (typeof dataSource == "string") {
                        item["editorOptions"]["dataSource"] = getStore({
                            url: url,
                            authStore: authStore,
                            cacheDuration: 0,
                            loadMode: "raw",
                            keyName: item["editorOptions"]["key"]
                                || item["editorOptions"]["keyExpr"]
                                || item["editorOptions"]["valueExpr"]
                                || "Id"
                        });
                    }
                    else if (typeof dataSource == "object") {
                        item["editorOptions"]["dataSource"]["store"] = getStore({
                            url: url,
                            authStore: authStore,
                            cacheDuration: 0,
                            loadMode: "raw",
                            keyName: item["editorOptions"]["key"]
                                || item["editorOptions"]["keyExpr"]
                                || item["editorOptions"]["valueExpr"]
                                || "Id"
                        });
                    }
                }
            }
        }
    }
    return items;
}

export default class ReportFormPreparer {
    public static formPrepare = (form: any, authStore: AuthStore) => {
        form = form || {};
        form["items"] = setItems(form["items"], authStore);
        return form;
    };
}

//https://stackoverflow.com/questions/41630617/how-to-submit-angular-form-with-devextreme